import { Auth } from 'aws-amplify';
import TrustedDeviceStorage from '../utils/trustedDeviceStorage.js';

const ApiService = {
  async register(data) {
    try {
      let res = await Auth.signUp(data);
      return res;
    } catch (error) {
      console.log('error: ', error);
      return false;
    }
  },
  async logIn(data) {
    try {
      let res = await Auth.signIn(data.email, data.password, {
        authFlowType: 'CUSTOM_WITH_SRP',
        ...TrustedDeviceStorage.clientMetadata(data.email),
      });
      return res;
    } catch (error) {
      console.log('error: ', error);
      return false;
    }
  },
  async authOtpSignUp(userName, data) {
    try {
      let res = await Auth.confirmSignUp(userName, data);
      return res;
    } catch (error) {
      console.log('error: ', error);
    }
  },
  async updateNewUserPassword(cognitoUser, data) {
    try {
      // let res = await Auth.signIn(data)
      let res = await Auth.completeNewPassword(
        cognitoUser,
        data.password,
        undefined,
        {
          authFlowType: 'CUSTOM_WITH_SRP',
        }
      );
      return res;
    } catch (error) {
      console.log('error: ', error);
      return false;
    }
  },
  async authOtpSignIn(cognitoUser, data) {
    try {
      let res = await Auth.sendCustomChallengeAnswer(cognitoUser, data);
      return res;
    } catch (error) {
      console.log('error: ', error);
      return false;
    }
  },
  async getCurrentLoginUser() {
    try {
      let res = await Auth.currentAuthenticatedUser();
      return res ? true : false;
    } catch (error) {
      console.log('error: ', error);
      return false;
    }
  },
  async AuthLogout() {
    try {
      let res = await Auth.signOut();
      return res;
    } catch (error) {
      console.log('error: ', error);
    }
  },
  async forgetPassword(email) {
    try {
      let res = await Auth.forgotPassword(email);
      return res;
    } catch (error) {
      console.log('error: ', error);
    }
  },
  async forgetPasswordSubmit(payload) {
    try {
      let res = await Auth.forgotPasswordSubmit(
        payload.email,
        payload.code,
        payload.password
      );
      return res;
    } catch (error) {
      console.log('error: ', error);
      throw error;
    }
  },
  async forgetPasswordResend(email) {
    try {
      let res = await Auth.resendSignUp(email);
      return res;
    } catch (error) {
      console.log('error: ', error);
    }
  },
  /** CUSTOM_AUTH cannot use Cognito rememberDevice(); trust is stored in localStorage (30-day TTL). */
  async rememberDevice(email) {
    return TrustedDeviceStorage.setTrusted(email);
  },
};
export default ApiService;
